import * as yup from "yup";

const schema = yup.object().shape({
  rejectionReason: yup
    .string()
    .trim()
    .notRequired()
    .matches(/^(?!\s+$).*/, "Please provide valid values for Rejection Remarks")
    .label("Rejection Reason"),

    rejectionType: yup
    .string()
    .required("Rejection Reason is required")
    .label("Rejection Reason"),
});

export default schema;
